import React from 'react';
import Btn, { BtnModifier } from '../../../../../components/molecules/Btn';
import { Icons } from '../../../../../components/atoms/SVG';
import { useSonTranslation } from '../../../../../translation/useSonTranslation';
import { ButtonRefType } from '../../../../../components/molecules/Btn/Btn';

type AcceptDeclineFormButtonsProps = {
  acceptButtonRef: ButtonRefType | undefined,
  declineButtonRef: ButtonRefType | undefined,
  buttonAriaDisabled: boolean,
  onDecline?: () => void,
};

export function AcceptDeclineFormButtons({
  acceptButtonRef,
  declineButtonRef,
  buttonAriaDisabled,
  onDecline,
}: AcceptDeclineFormButtonsProps) {
  const { t } = useSonTranslation('glossary');

  return (
    <div className="accept-decline-form__buttons">
      <Btn
        reference={acceptButtonRef}
        text={t('yes')}
        svgSpriteId={Icons.ACCEPT_CHECK}
        hiddenText
        type="submit"
        modifier={[BtnModifier.SINGLE_ACTION, BtnModifier.SINGLE_ACTION_YES]}
        ariaDisabled={buttonAriaDisabled}
      />
      <Btn
        reference={declineButtonRef}
        text={t('no')}
        svgSpriteId={Icons.DECLINE_CROSS}
        hiddenText
        type="button"
        onClick={onDecline}
        modifier={[BtnModifier.SINGLE_ACTION, BtnModifier.SINGLE_ACTION_NO]}
        ariaDisabled={buttonAriaDisabled}
      />
    </div>
  );
}
